import React, { useState, useCallback, ReactNode } from "react";

interface APILoadingContextValue {
  loading: boolean;
  showLoadingBackdrop: () => void;
  removeLoadingBackdrop: () => void;
}

export const APILoadingContext = React.createContext<APILoadingContextValue>({
  loading: false,
  showLoadingBackdrop: () => {},
  removeLoadingBackdrop: () => {},
});

export default function APILoadingProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const removeLoadingBackdrop = () => {
    setIsLoading(false);
  };

  const showLoadingBackdrop = () => {
    setIsLoading(true);
  };

  const contextValue = {
    loading: isLoading,
    showLoadingBackdrop: useCallback(() => showLoadingBackdrop(), []),
    removeLoadingBackdrop: useCallback(() => removeLoadingBackdrop(), []),
  };

  return (
    <APILoadingContext.Provider value={contextValue}>
      {children}
    </APILoadingContext.Provider>
  );
}
